import { Spacer } from "../Atoms"
import React, { FC, ReactNode } from "react"
import { NotLarge } from "components/views/atoms/Responsive"

type BodyWithRightSidebarLayoutProps = {
  sidebar?: ReactNode
  children: ReactNode
  bottomContent?: ReactNode
}

const BodyWithRightSidebarLayout: FC<BodyWithRightSidebarLayoutProps> = ({
  sidebar,
  children,
  bottomContent = null
}: BodyWithRightSidebarLayoutProps) => (
  <div className="w-100 flex flex-row">
    <div className="w-100 w-two-thirds-l mw-600 min-w384-l">
      {children}
      <NotLarge>{sidebar}</NotLarge>
      {bottomContent && (
        <>
          <NotLarge>
            <Spacer height={3} expand />
          </NotLarge>
          {bottomContent}
        </>
      )}
    </div>
    <div className="db-l dn">
      <Spacer width={3} />
    </div>
    {/* hide right sidebar if smaller than 960 */}
    <div className="w-100 w-third-l mw-320 min-w232-l db-l dn">{sidebar}</div>
  </div>
)

export { BodyWithRightSidebarLayout }
